import axios from 'axios';

import { interceptorAddToken, queryString } from './Api';
import config from '../config';
import StorageHelper from '../helpers/StorageHelper';

const ApiProduto = axios.create({
  baseURL: config.urlApiProduto,
  paramsSerializer: queryString,
});

ApiProduto.interceptors.request.use((config) =>
  interceptorAddToken(config, {
    token: StorageHelper.getTokenSistema(),
  }),
);

export default ApiProduto;
